import { Component, inject, OnInit } from '@angular/core';
import { IzipayPagePresenter } from './ui-commons/izipage-page.presenter';
import { tap } from 'rxjs';
import { FacadeLinkPaymentService } from '../../services/payment.service';
import { IEvent, PaymentBusEventsService } from '../../services/payment.busevents.service';
import { LoaderSubjectService } from 'app/shared/ui-commons/ui-spinner/util-commons/service/loader-subject.service';
import { UICardContainerComponent } from "../../../../shared/ui-commons/ui-card-page/ui-card-page.components";
import { NewRelicService } from '../../services/newRelic.service';

const DEFAULT_CURRENCY = 'PEN';
const CURRENCY_SYMBOLS: Record<string, string> = {
  PEN: 'S/',
  USD: '$.',
};

@Component({
  selector: 'cv-izipay-page',
  templateUrl: './izipay-page.component.html',
  styleUrls: ['./izipay-page.component.scss'],
  imports: [
    UICardContainerComponent
  ]
})
export class IzipayPageComponent implements OnInit {
  public ipp = new IzipayPagePresenter();
  private newRelicService = inject(NewRelicService);

  private readonly flps = inject(FacadeLinkPaymentService);
  private loader = inject(LoaderSubjectService);
  private pbes = inject(PaymentBusEventsService);

  ngOnInit(): void {
    this.pbes.eventBus$
      .pipe(
        tap((event: IEvent) => {
          this.newRelicService.addPageAction('OPEN_SDK_IZIPAY', {
            component: 'IzipayPageComponent',
            action: 'OPEN_SDK_IZIPAY',
            detail: 'El SDK de Izipay se ha abierto',
            timestamp: new Date().toISOString()
          });
          if (event.code === 'OPEN_GATEWAY_IZIPAY') {
            this.flps.loadIziPayGateway();
            this.loader.closeLoader();
            this.setGetDataResponseToForm(event);
          }
        })
      )
      .subscribe();
  }

  private setGetDataResponseToForm(event: IEvent) {
    this.newRelicService.addPageAction('OBTIENE_DATA_PRE_FORM', {
      component: 'IzipayPageComponent',
      action: 'setGetDataResponseToForm',
      detail: 'Se obtiene data:'
      + ' CustomerId: ' + event.infoIzipay?.customerId
      + ' Pan: ' + event.infoIzipay?.pan
      + ' OrderNumber: ' + event.infoIzipay?.orderNumber
      + ' TransactionId: ' + event.infoIzipay?.transactionId
      + ' Amount: ' + event.infoIzipay?.amount
      + ' Currency: ' + event.infoIzipay?.currency,
      timestamp: new Date().toISOString()
    });
    const currency = event.infoIzipay?.currency ?? DEFAULT_CURRENCY;

    this.ipp.form_paygateway.amount = event.infoIzipay?.amount ?? '0';
    this.ipp.form_paygateway.currency = CURRENCY_SYMBOLS[currency] || currency;
  }
}